import { useEffect } from "react";

function AdUnit() {

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
     data-ad-client="ca-pub-3659146594839061"
     data-ad-slot="8127041333"
     data-ad-format="auto"
     data-full-width-responsive="true">
      
     </ins>
  );
}

export default AdUnit;